// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum UserType {
    User = 0,
    SharedMailbox = 1,
    PublicMailbox = 2
}
